export const PERIOD_LABEL = {
  month: '本月',
  quarter: '本季',
  year: '本年',
  custom: '自定义'
}

export const PERIOD_LABEL_CUMULATIVE = {
  month: '本月累计',
  quarter: '本季度累计',
  year: '本年累计',
  custom: '区间累计'
}

export function formatPeriodLabel(period, startDate, endDate, cumulative = false) {
  const map = cumulative ? PERIOD_LABEL_CUMULATIVE : PERIOD_LABEL
  if (period === 'custom' && startDate && endDate) {
    return `${startDate} ~ ${endDate}`
  }
  return map[period] || map.year
}

export function buildPeriodParams(state) {
  const { period, periodStart, periodEnd } = state || {}
  const params = { period: period || 'year' }
  if (period === 'custom' && periodStart && periodEnd) {
    params.startDate = periodStart
    params.endDate = periodEnd
  }
  return params
}

export function dispatchPeriodChange(detail) {
  window.dispatchEvent(new CustomEvent('periodchange', { detail }))
}
